var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('help',{attrs:{"text":_vm.$t('help.tievent_create'),"title":_vm.$t('help.tievent_create_title')}}),_c('div',{key:_vm.$store.getters['resource/currentResource'].key},[_c('event-view',{on:{"save":_vm.saveEvent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }